
import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Container, Dialog, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Switch, Typography, TextField } from "@mui/material";
// import Dollar from './images/Dollar.png';
// import Visa from './images/Visa.png';
// import Credit from './images/Credit card.png';
import CloseIcon from '@mui/icons-material/Close'
import { Delete } from "@mui/icons-material";
import { AddPayMeth, DeletePayMeth, getDevicePayment, UpdatePayMeth } from "../../hooks/apiHandler";
import { useAuth } from "../../hooks/useAuth";
// import { position } from "html2canvas/dist/types/css/property-descriptors/position";



export const PaymentSetting = () => {
    const storeid = JSON.parse(window.localStorage.getItem('ds'));
    const { Logout } = useAuth();
    const [devicesPayment, setDevicePayment] = useState(
        {
            devices: [],
            PaymentSetting: {}
        }
    );

    const PayType = {
        Cash: 0,
        GiftCard: 1,
        Visa: 2,
        Mastercard: 3,
        CreditCard: 4,
        DebitCard: 5,
        PayPal: 6,
        ApplePay: 7,
        GooglePay: 8,
        SamsungPay: 9,
        BankTransfer: 10,
    };

    const initData = {
        model: false,
        deviceID: ''
    }

    const [open, openchange] = useState(initData);

    const closepopup = () => {
        openchange(initData);
    }
    useEffect(() => {
        async function fetchPaymentData() {
            var response = await getDevicePayment({ storeID: storeid }, Logout);
            if (await response.data) {
                console.log(response.data.paymentMode);
                setDevicePayment({
                    devices: response.data.paymentMode.devices,
                    paymentSetting: response.data.paymentSetting.paymentSetting
                });
                // set loading false...
            }
        }
        fetchPaymentData();


        return () => {

        }
        // eslint-disable-next-line
    }, [])

    const handelAddPayMethod = async (deviceID) => {
        console.log('Show Dialog for Payment');
        console.log(deviceID);
        openchange({ model: true, deviceID: deviceID });
    }

    const handleAddPayMethod = async (idex) => {
        const resp = await AddPayMeth({ storeID: storeid, deviceID: open.deviceID, PayMode: idex }, Logout);
        if (resp.code === 0) {
            const newData = resp.data.devices;
            setDevicePayment(prevState => ({
                ...prevState,
                devices: [...newData]
            }));
        } else {
            console.log(resp);
            console.log("Something Went Wrong...");
        }
    };


    // Example handler for toggling the switch
    // Client-side: Handle Payment Method Switch Change
    const handlePaymentSwitchChange = async (event, deviceID, payTypeID) => {

        const status = event.target.checked; // Get the new status from the switch
        const resp = await UpdatePayMeth({
            storeID: storeid,
            deviceID: deviceID,
            payTypeID: payTypeID,
            status: status
        }, Logout);
        if (resp.code === 0) {
            const newData = resp.data.devices;
            setDevicePayment(prevState => ({
                ...prevState,
                devices: [...newData]
            }));
        } else {
            console.log(resp);
            console.log("Something Went Wrong...");
        }
    };

    // Client-side: Handle Payment Method Deletion
    const handleDeletePayment = async (deviceID, payTypeIndex) => {
        console.log(deviceID, payTypeIndex);

        const resp = await DeletePayMeth({ storeID: storeid, deviceID: deviceID, payTypeID: payTypeIndex }, Logout);

        if (resp.code === 0) {
            const newData = resp.data.devices;
            setDevicePayment(prevState => ({
                ...prevState,
                devices: [...newData]
            }));
        } else {
            console.log(resp);
            console.log("Something Went Wrong...");
        }
    };


    const [formData, setFormData] = useState({
        discount1: "",
        discount2: "",
        discount3: "",
        discount4: "",
        discount5: "",
        discount6: "",
        discount7: "",
        discount8: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Discount Data:", formData);
        // send formData to API here
    };




    return (
        <Container sx={{ position: 'relative' }}>
            {
                devicesPayment.devices.length > 0 ? (
                    devicesPayment.devices.map((item, index) => (
                        <Paper key={'dev' + index} elevation={3} style={{ padding: 10, margin: 5 }}>
                            <Grid container spacing={1} alignItems="end">
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">
                                        {item.name} ({item.hid})
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} textAlign={"end"}>
                                    <Button variant="contained" onClick={() => handelAddPayMethod(item._id)}>+ Add Payment Method</Button>
                                </Grid>
                            </Grid>

                            <hr />
                            <List sx={{ width: "100%", bgcolor: "background.paper" }}>

                                {item.paymetModes.map((payment, index) => {
                                    // Map the payType index to the corresponding payment name

                                    const paymentName = Object.keys(PayType).find(key => PayType[key] === payment.payType);

                                    return (
                                        <ListItem key={'listMet' + payment.payType}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <Switch
                                                        checked={payment.enable}  // Dynamically update based on the enable status
                                                        onChange={(event) => handlePaymentSwitchChange(event, item._id, payment._id)} // Handle the switch change
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="h7">
                                                            {paymentName}  {/* Display the payment method name */}
                                                        </Typography>
                                                    }
                                                />
                                                <IconButton color="error" size="small" onClick={() => handleDeletePayment(item._id, payment._id)}>
                                                    <Delete />
                                                </IconButton>
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}

                            </List>
                        </Paper>)
                    )
                ) : 'Loading'
            }
            <br />
            <h4>Other Options :</h4>
            <hr />
            {/* <Grid container>
                <Grid item xs={11} md={8}>
                    Tip Option
                </Grid>
                <Grid item xs={1} md={1}>
                    <Switch
                        checked
                    />
                </Grid>
            </Grid> */}
            {/* <Grid container>
                <Grid item xs={11} md={8}>
                    Show order details to terminal
                </Grid>
                <Grid item xs={1} md={1}>
                    <Switch
                        checked
                    />
                </Grid>
            </Grid> */}
            <Grid container spacing={4} sx={{ paddingTop: "20px" }}>
                {/* <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="h6"> Tip Option </Typography>
                            <Switch
                                checked
                                onChange={() =>{}}
                            />
                        </Box>
                        <p>Enabel or Disabel Tip From POS</p>
                    </Card>
                </Grid> */}
                <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="h6">Terminal Settings </Typography>

                        </Box>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <p>Show Order details to terminal</p>
                            <Switch
                                checked
                                onChange={() => { }}
                            />
                        </Box>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="p"> Tip Option </Typography>
                            <Switch
                                checked
                                onChange={() => { }}
                            />
                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="h6">Discount Settings </Typography>
                            <Switch
                                checked
                                onChange={() => { }}
                            />
                        </Box>
                        <p>Enabel Discount Option During check-out</p>
                        <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="h6">Discount Settings </Typography>
                            <Switch
                                checked
                                onChange={() => { }}
                            />
                        </Box>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                {/* Discount 1–4 */}
                                <Grid item xs={12}>
                                    <Typography variant="p">
                                        Discount In Percentage (%)
                                    </Typography>
                                </Grid>
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <TextField
                                            fullWidth
                                            label={`Discount ${index + 1}`}
                                            name={`discount${index + 1}`}
                                            value={formData[`discount${index + 1}`]}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                ))}

                                {/* Image Section */}
                                <Grid item xs={12}>
                                    <Typography variant="p">
                                        Discount In Cash
                                    </Typography>
                                </Grid>

                                {/* Discount 5–8 */}
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <Grid item xs={12} sm={6} key={index + 4}>
                                        <TextField
                                            fullWidth
                                            label={`Discount ${index + 1}`}
                                            name={`discount${index + 5}`}
                                            value={formData[`discount${index + 5}`]}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                ))}

                                {/* Submit */}
                                <Grid item xs={12}>
                                    <Button type="submit" variant="contained" color="primary" fullWidth>
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>

                    </Card>
                </Grid>
            </Grid>

            <Dialog open={open.model} onClose={closepopup} fullWidth maxWidth="sm">
                <DialogTitle><IconButton style={{ float: 'right' }} onClick={() => {
                    closepopup()
                }}><CloseIcon color='primary' ></CloseIcon></IconButton>
                    <div> <h2 className='Form_title'>Add Payment Option</h2></div>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        spacing={2}
                        columns={{ xs: 2, sm: 3, md: 3 }}
                    >
                        {Object.entries(PayType).map(([key, value]) => (
                            <Grid key={'md-' + key} item xs={2} sm={1} md={1}>
                                <Card elevation={2} onClick={() => handleAddPayMethod(value)}
                                    sx={{ cursor: "pointer" }}>
                                    <CardContent>
                                        <center>
                                            <Typography gutterBottom variant="h6" component="div">
                                                {key}
                                            </Typography>
                                            {/* {paymentImages[key] && ( // Ensure image exists before rendering
                                                <img src={paymentImages[key]} alt={key} />
                                            )} */}
                                            <br />
                                        </center>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}

                    </Grid>
                </DialogContent>
                {/* <Button onClick={()=>{
  closepopup()
 }} color="error" variant="contained">close</Button> */}
            </Dialog>
            {/* Following Box Need to Remove Once this Page is Fully Ready */}
            <Box sx={{ position: 'absolute', width: '100%', height: '100%', background: '#ffffffe0', left: 0, top: 0, display: "flex", justifyContent: 'center', alignItems: 'center' }} >
                <Typography sx={{ fontSize: '34px' }}> Coming Soon</Typography>
            </Box>
        </Container>



    )
}